import React, { useEffect } from 'react';
import { trackClick } from 'js/utils/trackClick';
import {
  recordShow,
  recordDismissal,
  recordClickthrough,
} from 'js/utils/dismissibles';
import routes from 'js/core_pre_webpack/routes';

import { CommonModal } from './common';

type Props = {
  offer: 'price' | 'discount';
  value: string;
  mentions?: number;
  onClose: () => void;
};

export default function ChurnedUserReactivationModal({
  offer,
  value,
  mentions,
  onClose,
}: Props) {
  const nagName = 'ChurnedUserReactivationModal';

  useEffect(() => {
    recordShow(nagName);
  }, []);

  const clickThrough = () => {
    recordClickthrough(nagName);
    trackClick({
      source: 'churned_user_reactivation_modal',
      extra: {},
    });
    window.location.href = routes.checkout_path({
      feature: 'churned_user_reactivation',
      trigger: 'reactivate_modal',
    });
  };

  const hide = () => {
    recordDismissal(nagName);
    onClose();
  };

  let ctaText;
  let buttonText;
  if (offer === 'discount') {
    ctaText = mentions
      ? `See your ${mentions} new Mentions, ${value} OFF Premium`
      : `Accelerate your research, ${value} OFF Premium`;
    buttonText = `Reactivate Premium, ${value} OFF ▸`;
  } else {
    ctaText = mentions
      ? `See your ${mentions} new Mentions for just ${value}`
      : `Accelerate your research with Premium for just ${value}`;
    buttonText = `Reactivate Premium for ${value} ▸`;
  }

  return <CommonModal {...{ ctaText, buttonText, clickThrough, hide }} />;
}
